/**
 * 供应商评价相关工具函数
 */

/**
 * 获取评价分类的颜色
 * @param classification 评价分类文本或翻译后的文本
 */
export const getClassificationColor = (classification: string): string => {
  const c = classification?.toLowerCase() || ''
  // 引进评价
  if (classification === '引进' || c.includes('introduced')) return 'green'
  if (classification === '储备' || c.includes('reserved')) return 'orange'
  if (classification === '不引进' || c.includes('rejected') || c.includes('not introduced')) return 'gray'
  // 使用评级
  if (classification === '优秀' || c.includes('excellent')) return 'green'
  if (classification === '良好' || c.includes('good')) return 'blue'
  if (classification === '合作' || c.includes('cooperating')) return 'orange'
  if (classification === '限时整改' || c.includes('rectifying')) return 'red'
  return 'gray'
}

/**
 * 获取评价分类文本
 * @param result 评价结果
 * @param score 总评分
 * @param evaluationType 评价类型(1-引进评价, 2-使用评级)
 * @param t 国际化函数
 */
export const getClassificationText = (
  result: number | null | undefined,
  score: number,
  evaluationType: number,
  t?: (key: string) => string
): string => {
  const translate = t || ((key: string) => {
    // 简单的回退逻辑
    const map: Record<string, string> = {
      'saas.supplierManagement.enums.introduce.introduced': '引进',
      'saas.supplierManagement.enums.introduce.reserved': '储备',
      'saas.supplierManagement.enums.introduce.rejected': '不引进',
      'saas.supplierManagement.enums.usage.excellent': '优秀',
      'saas.supplierManagement.enums.usage.good': '良好',
      'saas.supplierManagement.enums.usage.cooperating': '合作',
      'saas.supplierManagement.enums.usage.rectifying': '限时整改',
      'common.unknown': '未知'
    }
    return map[key] || key
  })

  // 引进评价
  if (evaluationType === 1) {
    let key = 'saas.supplierManagement.enums.introduce.rejected'
    if (result === 1 || (result === null && score >= 80)) key = 'saas.supplierManagement.enums.introduce.introduced'
    else if (result === 2 || (result === null && score >= 60)) key = 'saas.supplierManagement.enums.introduce.reserved'
    return translate(key)
  }
  // 使用评级
  else if (evaluationType === 2) {
    let key = 'saas.supplierManagement.enums.usage.rectifying'
    if (result === 1 || (result === null && score >= 85)) key = 'saas.supplierManagement.enums.usage.excellent'
    else if (result === 2 || (result === null && score >= 70)) key = 'saas.supplierManagement.enums.usage.good'
    else if (result === 3 || (result === null && score >= 60)) key = 'saas.supplierManagement.enums.usage.cooperating'
    return translate(key)
  }
  return translate('common.unknown')
}
